import _reduce from 'lodash/reduce';
import {InsightsObj} from '../campaignAnalytics.types';
import {MetricValue} from 'common/src/modules/analytics/analytics.types';

export function getEmptyInsightsObj(metrics: MetricValue[]): InsightsObj {
  return _reduce(
    metrics,
    (acc, metric) => {
      return {
        ...acc,
        [metric]: {value: 0, percentageOfTotal: 0, proportionalSize: 0},
      };
    },
    {} as InsightsObj,
  );
}
